import { render, staticRenderFns } from "./CreateUserDialog.vue?vue&type=template&id=f56aaff8&scoped=true&"
import script from "./CreateUserDialog.vue?vue&type=script&lang=js&"
export * from "./CreateUserDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateUserDialog.vue?vue&type=style&index=0&id=f56aaff8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56aaff8",
  null
  
)

export default component.exports